// ============================================================================
// Configuration Constants
// ============================================================================
export const LIVE_CONSTANTS = {
    // Subscription limits
    MAX_SPACE_SUBSCRIPTIONS: 16, // Max spaces a user can subscribe to simultaneously
    MAX_DEVICES_PER_USER: 5, // Max devices per user
    // Channel participation
    DEFAULT_STAGE_SIZE: 5, // Default number of users allowed on stage
    MAX_STAGE_SIZE: 20, // Maximum stage size that can be set
    DEFAULT_STAGE_PAGINATION_LIMIT: 360, // Number of users per page in paginated stage lists
    DEFAULT_LISTENER_PAGINATION_LIMIT: 16, // Number of users per page in paginated lists
    DEFAULT_SUBSCRIBER_PAGINATION_LIMIT: 32, // Number of users per page in paginated subscribers list
    // Connection lifecycle
    GRACE_PERIOD_SHORT_MS: 1_000, // 1 second grace period after normal disconnect
    GRACE_PERIOD_LONG_MS: 30_000, // 30 seconds grace period after abnormal disconnect
    // Message validation
    MAX_MESSAGE_SIZE_BYTES: 65_536, // 64KB max message size
    // Rate limiting (per user)
    RATE_LIMITS: {
        SUBSCRIBE_PER_MINUTE: 100, // Max subscribe requests per minute
        JOIN_CHANNEL_PER_MINUTE: 15, // Max channel join/leave per minute
        WINDOW_SIZE_MS: 60_000, // 1 minute window for rate limiting
    },
};
// ============================================================================
// Error Codes
// ============================================================================
export var LiveErrorCode;
(function (LiveErrorCode) {
    // Permission errors
    LiveErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    LiveErrorCode["NOT_ENTITLED_TO_SPACE"] = "NOT_ENTITLED_TO_SPACE";
    LiveErrorCode["NOT_ENTITLED_TO_CHANNEL"] = "NOT_ENTITLED_TO_CHANNEL";
    // Validation errors
    LiveErrorCode["INVALID_MESSAGE_FORMAT"] = "INVALID_MESSAGE_FORMAT";
    LiveErrorCode["MESSAGE_TOO_LARGE"] = "MESSAGE_TOO_LARGE";
    LiveErrorCode["TOO_MANY_SUBSCRIPTIONS"] = "TOO_MANY_SUBSCRIPTIONS";
    LiveErrorCode["TOO_MANY_DEVICES"] = "TOO_MANY_DEVICES";
    LiveErrorCode["ALREADY_CONNECTED"] = "ALREADY_CONNECTED";
    // Rate limiting
    LiveErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    // State errors
    LiveErrorCode["NOT_SUBSCRIBED_TO_SPACE"] = "NOT_SUBSCRIBED_TO_SPACE";
    LiveErrorCode["ALREADY_IN_CHANNEL"] = "ALREADY_IN_CHANNEL";
    LiveErrorCode["NOT_IN_CHANNEL"] = "NOT_IN_CHANNEL";
    // Resource errors
    LiveErrorCode["SPACE_NOT_FOUND"] = "SPACE_NOT_FOUND";
    LiveErrorCode["CHANNEL_NOT_FOUND"] = "CHANNEL_NOT_FOUND";
    LiveErrorCode["SPACE_HUB_UNAVAILABLE"] = "SPACE_HUB_UNAVAILABLE";
    // Generic errors
    LiveErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    LiveErrorCode["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
})(LiveErrorCode || (LiveErrorCode = {}));
